/* eslint-disable no-unused-vars */
import { IconButton, InputBase, Stack } from '@mui/material';
import React from 'react';
import './SearchBox.css';
import SearchIcon from '@mui/icons-material/Search';

export type ISearchBoxProps = {
  placeholder?: string;
  onChange?: (searchTerm: string) => void;
};

const SearchBox: React.FC<ISearchBoxProps> = ({ placeholder, onChange }) => {
  let timer: number | undefined;

  /**
   * used for debounce limited searching
   */
  const debounce = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (onChange !== undefined) {
        onChange(e.target.value);
      }
    }, 800) as any;
  };

  return (
    <Stack
      className="searchBoxContainer"
      direction="row"
    >
      <InputBase
        sx={{ m: '7px', pl: '10px', flex: 1 }}
        placeholder={`${placeholder ?? 'Search'}...`}
        onChange={debounce}
      />
      <IconButton
        size="large"
      >
        <SearchIcon />
      </IconButton>
    </Stack>
  );
};

export { SearchBox };
